module.exports = __webpack_public_path__ + "img/avatar0.ec37c42d.png";